/*
 * @Desc: 区域 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: lc
 * @LastEditTime: 2023-09-04 08:34:28
 */
import request from "@/utils/request";
const area = {
    select (query) {
        return request({
            url: "/area/select",
            method: "get",
            params: query
        });
    },
    sort (query) {
        return request({
            url: "/area/sort",
            method: "post",
            params: query
        });
    },
    // 列表
    create (query) {
        return request({
            url: "/area/create",
            method: "post",
            params: query
        });
    },
    edit (query) {
        return request({
            url: "/area/edit",
            method: "post",
            params: query
        });
    },
    detail (query) {
        return request({
            url: "/area/detail",
            method: "get",
            params: query
        });
    },
    remove (query) {
        return request({
            url: "/area/remove",
            method: "post",
            params: query
        });
    },
    list (query) {
        return request({
            url: "/area/list",
            method: "get",
            params: query
        });
    },
};
export default area;
